import MovieCard from "./MovieCard";

const MovieList = ({ title, nowplaying }) => {
 
  

  return (
    <div className="  md:pt-4 p-2 ">
      <button className="  font-extrabold px-4 shadow-inner underline rounded-xl leading-tight text-white opacity-90 md:text-3xl lg:text-3xl">{title}</button>
      <div className="flex overflow-x-scroll   ">
        {/* Parent container with overflow */}
        <div className=" flex  ">
          {nowplaying &&
            nowplaying.map((video) => (
              <MovieCard key={video.id} movie={video.poster_path} />
            ))}
        </div>
      </div>
    </div>
  );
};
export default MovieList;
